import React from 'react';

const RiskScoreCard = ({ score = 42 }) => {
  const getLevel = (s) => {
    if (s <= 30) return { label: 'Low Risk', color: '#00FF88', desc: 'This property has minimal risk factors.' };
    if (s <= 60) return { label: 'Moderate Risk', color: '#FFAA00', desc: 'Some risk factors identified. Proceed with due diligence.' };
    return { label: 'High Risk', color: '#FF4444', desc: 'Significant risks detected. Careful investigation required.' };
  };
  const level = getLevel(score);
  const circumference = 2 * Math.PI * 45;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div className="bg-card rounded-xl border border-border p-6 flex flex-col items-center">
      <h3 className="text-lg font-semibold text-foreground mb-4 self-start">Overall Risk Score</h3>
      <div className="relative w-32 h-32 mb-4">
        <svg className="w-full h-full -rotate-90" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="8" />
          <circle cx="50" cy="50" r="45" fill="none" stroke={level?.color} strokeWidth="8" strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" style={{ transition: 'stroke-dashoffset 1s ease', filter: `drop-shadow(0 0 6px ${level?.color})` }} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-bold" style={{ color: level?.color }}>{score}</span>
          <span className="text-xs text-muted-foreground">/ 100</span>
        </div>
      </div>
      <p className="text-lg font-semibold mb-1" style={{ color: level?.color }}>{level?.label}</p>
      <p className="text-sm text-muted-foreground text-center">{level?.desc}</p>
      <div className="mt-4 w-full grid grid-cols-3 gap-2 text-center">
        {[{ label: 'Flagged', value: '4', color: '#FF4444' }, { label: 'Warnings', value: '3', color: '#FFAA00' }, { label: 'Clear', value: '6', color: '#00FF88' }]?.map((s, i) => (
          <div key={i} className="p-2 rounded-lg bg-muted/30">
            <p className="text-lg font-bold" style={{ color: s?.color }}>{s?.value}</p>
            <p className="text-xs text-muted-foreground">{s?.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskScoreCard;
